function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30 11A4 4 0 1 0 30 19 4 4 0 1 0 30 11zM32.121 20.329l-2.16 5.416-4.577 1.352 1.379 3.75 6.274-2.119 1.79-3.948 3.03 2.8-5.079 4.838-.772 1.443-1.982 6.83 3.946.595 1.938-6.108 5.395-4.382-1.224 4.661.628 2.056 6.062 5.061 2.524-3.111-4.82-3.846 1.497-7.135-1.047-2.797-5.672-6.672-3.269-.839-2.629.923L32.121 20.329z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26 27A2 2 0 1 0 26 31 2 2 0 1 0 26 27zM32 39A2 2 0 1 0 32 43 2 2 0 1 0 32 39zM34 32A2 2 0 1 0 34 36 2 2 0 1 0 34 32zM34 19A2 2 0 1 0 34 23 2 2 0 1 0 34 19z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37 18A3 3 0 1 0 37 24 3 3 0 1 0 37 18zM48 39A2 2 0 1 0 48 43 2 2 0 1 0 48 39zM42 34A2 2 0 1 0 42 38 2 2 0 1 0 42 34zM43 25A3 3 0 1 0 43 31 3 3 0 1 0 43 25zM16 6A4 4 0 1 0 16 14 4 4 0 1 0 16 6zM15.649 16.099l-2.629-.923-3.64 1.37-4.84 7.735L4 26v7.619l-3.696 6.327 3.447 2.013 3.925-6.862.303-.836.898-5.478 4.916 4.676 2.284 8.081 3.837-1.123-1.999-7.991-.457-.788-5.312-6.056 2.03-3.8 2.259 4.171C16.782 26.598 17.457 27 18.191 27H23v-4h-3.96l-2.16-5.671L15.649 16.099z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23 23A2 2 0 1 0 23 27 2 2 0 1 0 23 23zM18 39A2 2 0 1 0 18 43 2 2 0 1 0 18 39zM6 32A2 2 0 1 0 6 36 2 2 0 1 0 6 32zM15 16A2 2 0 1 0 15 20 2 2 0 1 0 15 16z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12 15A3 3 0 1 0 12 21 3 3 0 1 0 12 15zM2 39A2 2 0 1 0 2 43 2 2 0 1 0 2 39zM16 31A2 2 0 1 0 16 35 2 2 0 1 0 16 31zM7 23A3 3 0 1 0 7 29 3 3 0 1 0 7 23z"
});

function SvgWrestling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrestling);
export default __webpack_public_path__ + "static/media/wrestling.1e690c3a.svg";
export { ForwardRef as ReactComponent };